export const isUnhandledChatOpenRequest = <T>(
  handledRequest: T | null,
  pendingRequest: T | null,
): pendingRequest is T =>
  pendingRequest !== null && pendingRequest !== handledRequest;
